import { render, staticRenderFns } from "./Igienizare_Overdue.vue?vue&type=template&id=286602e8"
import script from "./Igienizare_Overdue.vue?vue&type=script&lang=js"
export * from "./Igienizare_Overdue.vue?vue&type=script&lang=js"
import style0 from "./Igienizare_Overdue.vue?vue&type=style&index=0&id=286602e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports